var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserIcnUnclicked({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 22 24",
    style: {
      enableBackground: "new 0 0 22 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#999999;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M20.8,22.9h-8.5h-1.2h-0.2H9.7H1.2V20c0-0.3,0.1-0.5,0.4-0.6c1.1-0.5,4.1-1.5,6-2.1c1-0.3,1-1.2,1-1.8 c0-0.9-0.1-1.5-0.4-2.1c-0.2-0.4-0.4-1.1-0.5-1.7l0-0.3l-0.2-0.3C7.3,11,7,10.6,6.8,9.5c-0.2-0.8-0.1-1,0-1.2 c0-0.1,0.1-0.2,0.1-0.3v0l0,0c0.1-0.5,0-2.1-0.2-3c-0.1-0.4,0-1.5,0.8-2.5c0.5-0.6,1.4-1.3,3-1.4h1.1c1.3,0.1,2.4,0.6,3,1.4 c0.8,1,0.8,2.1,0.8,2.5c-0.2,0.9-0.3,2.5-0.2,3l0,0l0,0l0.1,0.2l0,0c0.1,0.2,0.1,0.4,0,1.2c-0.2,1.1-0.5,1.5-0.7,1.6l-0.2,0.3 l-0.1,0.3c-0.1,0.6-0.3,1.4-0.5,1.7c-0.3,0.6-0.5,1.3-0.5,2c0,0.6,0,1.5,1,1.8c1.8,0.5,4.8,1.6,6,2.1c0.5,0.2,0.6,0.5,0.6,0.7V22.9 z M20.7,18.3c-1.3-0.5-4.3-1.5-6.1-2.1c-0.2,0-0.2-0.1-0.2-0.7c0-0.5,0.2-1.1,0.4-1.5c0.2-0.5,0.5-1.3,0.6-2.1 c0.3-0.3,0.7-1,0.9-2.2c0.2-1.1,0.1-1.4,0-1.8l0-0.1c0-0.2,0-1.6,0.2-2.6c0.1-0.7,0-2.2-1-3.4c-0.6-0.8-1.8-1.7-3.9-1.9h-1.2 C8.3,0.1,7.1,1.1,6.5,1.9c-1,1.2-1.1,2.7-1,3.4c0.2,1,0.3,2.3,0.2,2.6l0,0.1c-0.1,0.4-0.2,0.7,0,1.8c0.2,1.2,0.6,1.8,0.9,2.2 c0.1,0.8,0.4,1.6,0.6,2.1c0.2,0.4,0.3,0.9,0.3,1.6c0,0.7,0,0.7-0.2,0.7c-1.9,0.6-5,1.6-6.1,2.1C0.2,18.8,0,19.4,0,20v2.9 C0,23.3,0.2,24,1.1,24h8.6h1.2h0.2h1.2h8.5c0.9,0,1.1-0.7,1.1-1.1V20C22,19.4,21.6,18.7,20.7,18.3z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserIcnUnclicked);
export default __webpack_public_path__ + "static/media/user_icn_unclicked.3478aa32b8728fc7c26cd8aba01916a6.svg";
export { ForwardRef as ReactComponent };